module.exports = __webpack_public_path__ + "static/media/back.50aa6cdd.svg";